import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "types"
import { useApi } from "utils"

type LocationListSchema = {
  location_id: number
  location_name: string
}

export const useGetDropdownLocation = () => {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
  
    api.get("/location/")
    .then((res: SuccessFetch<{ payload: LocationListSchema[] }>) => {
      setData(res.data.payload.map(item => ({
        label: item.location_name,
        value: item.location_id.toString()
      })));
    })
    .catch(() => setData([]) )
    .finally(() => setLoading(false))
  
    return () => {
      setData([])
      setLoading(true)
    }
    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}